'use client';

import {SwitchLanguage} from '@ui-kit/src/SwitchLanguage';
import {usePathname} from 'next/navigation';

import SwitchLanguageComponentPrevVersion from '@dev-landing/components/SwitchLanguageComponent/SwitchLanguageComponentPrevVersion';

export const SwitchLanguageComponent = ({
  newTypeView,
  isHeader,
}: {
  newTypeView: boolean;
  isHeader?: boolean;
}) => {
  const pathName = usePathname();
  const isBlog = pathName?.includes('/blog');
  if (isBlog) return null;
  return (
    <div style={{marginTop: '24px'}}>
      {newTypeView && <SwitchLanguage isHeader={isHeader} />}
      {!newTypeView && <SwitchLanguageComponentPrevVersion />}
    </div>
  );
};
